import { flow, types } from "mobx-state-tree"
import { reaction } from "mobx"
import Api from '../api/Api'
import _ from 'lodash'
import jwt_decode from 'jwt-decode'
import State, {pending, error, done, notLoaded} from './State'

const localStorageTokenName = 'token';

const UserStore = types.model({
  user: types.frozen(),
  userState: types.optional(State, pending),
  loginState: types.optional(State, notLoaded),
  token: types.maybe(types.string)
})
.views(self => ({
  get isAuthenticated(){
    if(!self.token) return false;
    var decoded = jwt_decode(self.token);
    var current_time = new Date().getTime() / 1000;
    return current_time < decoded.exp 
  }
}))
.actions(self => ({
  fetchUser: flow(function* fetchUser() {
      self.user = undefined
      self.userState = pending
      try {
          const response = yield Api.get('/users/me/')
          self.user = response.data
          self.userState = done
      } catch (e) {
          console.error(e)
          self.userState = error
      }
  }),
  login: flow(function* login(username, password) {
    self.loginState = pending
    try {
        const response = yield Api.post('/token/', { username, password} )
        self.token = _.get(response, 'data.token')
        self.loginState = done
    } catch (e) {
        console.error(e)
        self.loginState = error
    }
  }),
  logout: ()=>{
    self.token = undefined;
  }
}))

const userStore = UserStore.create({token: localStorage.getItem(localStorageTokenName) ? localStorage.getItem(localStorageTokenName) : undefined})
reaction(
  ()=>userStore.token,
  (token)=>token ? localStorage.setItem(localStorageTokenName, token) : localStorage.removeItem(localStorageTokenName)
)
export default userStore


// WEBPACK FOOTER //
// ./src/stores/UserStore.js